import $ from 'jquery';
import debounce from 'lodash.debounce';

const DEBOUNCE_TIMEOUT = 20; 

class ScrolledIntoView {
    constructor({trigger, offset}) {
        this.$els = $(trigger);
        this.inViewCl = `${trigger.slice(1)}--in-view`;
        this.offset = typeof offset !== 'undefined'
            ? offset 
            : 0; 

        $(window).scroll(debounce(this.handleScroll, DEBOUNCE_TIMEOUT));
    }

    handleScroll = () => {
        [].forEach.call(this.$els, (el) => {
            if(this.isScrolledIntoView(el)) {
                $(el).addClass(`${this.inViewCl}`)
            } 
        });
    }

    isScrolledIntoView(el) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elTop = $(el).offset().top - this.offset;
        const elBottom = elTop + $(el).height();

        return ((elBottom <= docViewBottom) 
            && (elTop >= docViewTop));
    }
}

export default ScrolledIntoView;
